import styled from 'styled-components';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { ChevronDown16, ChevronUp16 } from 'ui/icons';

const ChevronIconWrapper = styled(IconButton)<{ isExpanded: boolean }>`
  display: ${({ isExpanded }) => (isExpanded ? 'inherit' : 'none')};
`;

type Props = {
  isExpanded: boolean;
  onClick: (isExpanded: boolean) => void;
};

export const ExpandableChevron = ({ isExpanded, onClick }: Props) => {
  return (
    <>
      {isExpanded ? (
        <ChevronIconWrapper
          onClick={() => onClick(!isExpanded)}
          variant={BUTTON_VARIANTS.GHOST}
          size={BUTTON_SIZES.SMALL}
          isExpanded
        >
          <ChevronUp16 />
        </ChevronIconWrapper>
      ) : (
        <ChevronIconWrapper
          onClick={() => onClick(!isExpanded)}
          variant={BUTTON_VARIANTS.GHOST}
          size={BUTTON_SIZES.SMALL}
          isExpanded
        >
          <ChevronDown16 />
        </ChevronIconWrapper>
      )}
    </>
  );
};
